import { useState, useEffect } from 'react'
import * as liveRegion from '../../helpers/live_region_helper'
import { pluralize } from '../../helpers/grammar_helper'

export default function useAnnounceResults() {
  const [resultCount, setResultCount] = useState(null)

  useEffect(() => {
    return () => liveRegion.polite.clearContent()
  }, [])

  useEffect(() => {
    if (resultCount != null) {
      liveRegion.polite.setContent(`${resultCount} ${pluralize('result', resultCount)} found`)
    }
  }, [resultCount])

  return setResultCount
}
